import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { EasyDgdService, DownloadModel } from '@hazmatsuite-next/easydgd-lib';
import { Observable } from 'rxjs';

export const downloadPageResolver: ResolveFn<Observable<DownloadModel>> = (route, state): Observable<DownloadModel> => {
  const service = inject(EasyDgdService);
  return service.checkout();
};
